import { HEADER_HEIGHT } from '@/components/header/constants';

export const SEARCH_PANEL_HEIGHT = 92;
export const ACTION_PANEL_HEIGHT = 44;
export const SELECTED_FILTER_HEIGHT = 60;

export const HEADERS_PANEL_HEIGHT =
  HEADER_HEIGHT + SEARCH_PANEL_HEIGHT + ACTION_PANEL_HEIGHT + SELECTED_FILTER_HEIGHT;
